import React from 'react';
import { Paper, Typography } from '@mui/material';
import './AccessDenied.css';

const AccessDenied = ({ message }) => {
  return (
    <Paper className="access-denied-container">
      <Typography variant="h6" color="textSecondary">
        Access Denied
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className="access-denied-message"
      >
        {message ||
          "You don't have permission to access this section. Contact your administrator."}
      </Typography>
    </Paper>
  );
};

export default AccessDenied;
